// Generated file - do not change manually!

/**
 * Different illustration types of Illustrated Message.
 */
export enum IllustrationMessageType {
  /**
   * "Add Column" illustration type.
   */
  AddColumn = 'AddColumn',

  /**
   * "Add People" illustration type.
   */
  AddPeople = 'AddPeople',

  /**
   * "Balloon Sky" illustration type.
   */
  BalloonSky = 'BalloonSky',

  /**
   * "Before Search" illustration type.
   */
  BeforeSearch = 'BeforeSearch',

  /**
   * "Connection" illustration type.
   */
  Connection = 'Connection',

  /**
   * "Empty Calendar" illustration type.
   */
  EmptyCalendar = 'EmptyCalendar',

  /**
   * "Empty List" illustration type.
   */
  EmptyList = 'EmptyList',

  /**
   * "Empty Planning Calendar" illustration type.
   */
  EmptyPlanningCalendar = 'EmptyPlanningCalendar',

  /**
   * "Error Screen" illustration type.
   */
  ErrorScreen = 'ErrorScreen',

  /**
   * "Filter Table" illustration type.
   */
  FilterTable = 'FilterTable',

  /**
   * "Group Table" illustration type.
   */
  GroupTable = 'GroupTable',

  /**
   * "No Activities" illustration type.
   */
  NoActivities = 'NoActivities',

  /**
   * "No Data" illustration type.
   */
  NoData = 'NoData',

  /**
   * "No Entries" illustration type.
   */
  NoEntries = 'NoEntries',

  /**
   * "No Filter Results" illustration type.
   */
  NoFilterResults = 'NoFilterResults',

  /**
   * "No Email" illustration type.
   */
  NoMail = 'NoMail',

  /**
   * "No Email v1" illustration type.
   */
  NoMail_v1 = 'NoMail_v1',

  /**
   * "No Notifications" illustration type.
   */
  NoNotifications = 'NoNotifications',

  /**
   * "No Saved Items" illustration type.
   */
  NoSavedItems = 'NoSavedItems',

  /**
   * "No Saved Items v1" illustration type.
   */
  NoSavedItems_v1 = 'NoSavedItems_v1',

  /**
   * "No Search Results" illustration type.
   */
  NoSearchResults = 'NoSearchResults',

  /**
   * "No Tasks" illustration type.
   */
  NoTasks = 'NoTasks',

  /**
   * "No Tasks v1" illustration type.
   */
  NoTasks_v1 = 'NoTasks_v1',

  /**
   * "Page Not Found" illustration type.
   */
  PageNotFound = 'PageNotFound',

  /**
   * "Reload Screen" illustration type.
   */
  ReloadScreen = 'ReloadScreen',

  /**
   * "Resize Column" illustration type.
   */
  ResizeColumn = 'ResizeColumn',

  /**
   * "Search Earth" illustration type.
   */
  SearchEarth = 'SearchEarth',

  /**
   * "Search Folder" illustration type.
   */
  SearchFolder = 'SearchFolder',

  /**
   * "Simple Balloon" illustration type.
   */
  SimpleBalloon = 'SimpleBalloon',

  /**
   * "Simple Bell" illustration type.
   */
  SimpleBell = 'SimpleBell',

  /**
   * "Simple Calendar" illustration type.
   */
  SimpleCalendar = 'SimpleCalendar',

  /**
   * "Simple CheckMark" illustration type.
   */
  SimpleCheckMark = 'SimpleCheckMark',

  /**
   * "Simple Connection" illustration type.
   */
  SimpleConnection = 'SimpleConnection',

  /**
   * "Simple Empty Doc" illustration type.
   */
  SimpleEmptyDoc = 'SimpleEmptyDoc',

  /**
   * "Simple Empty List" illustration type.
   */
  SimpleEmptyList = 'SimpleEmptyList',

  /**
   * "Simple Error" illustration type.
   */
  SimpleError = 'SimpleError',

  /**
   * "Simple Magnifier" illustration type.
   */
  SimpleMagnifier = 'SimpleMagnifier',

  /**
   * "Simple Mail" illustration type.
   */
  SimpleMail = 'SimpleMail',

  /**
   * "Simple No Saved Items" illustration type.
   */
  SimpleNoSavedItems = 'SimpleNoSavedItems',

  /**
   * "Simple Not Found Magnifier" illustration type.
   */
  SimpleNotFoundMagnifier = 'SimpleNotFoundMagnifier',

  /**
   * "Simple Reload" illustration type.
   */
  SimpleReload = 'SimpleReload',

  /**
   * "Simple Task" illustration type.
   */
  SimpleTask = 'SimpleTask',

  /**
   * "Sleeping Bell" illustration type.
   */
  SleepingBell = 'SleepingBell',

  /**
   * "Sort Column" illustration type.
   */
  SortColumn = 'SortColumn',

  /**
   * "Success Balloon" illustration type.
   */
  SuccessBalloon = 'SuccessBalloon',

  /**
   * "Success CheckMark" illustration type.
   */
  SuccessCheckMark = 'SuccessCheckMark',

  /**
   * "Success HighFive" illustration type.
   */
  SuccessHighFive = 'SuccessHighFive',

  /**
   * "Success Screen" illustration type.
   */
  SuccessScreen = 'SuccessScreen',

  /**
   * "Tent" illustration type.
   */
  Tent = 'Tent',

  /**
   * "TntCodePlaceholder" illustration type.
   */
  TntCodePlaceholder = 'TntCodePlaceholder',

  /**
   * "TntCompany" illustration type.
   */
  TntCompany = 'TntCompany',

  /**
   * "TntExternalLink" illustration type.
   */
  TntExternalLink = 'TntExternalLink',

  /**
   * "TntFaceID" illustration type.
   */
  TntFaceID = 'TntFaceID',

  /**
   * "TntFingerprint" illustration type.
   */
  TntFingerprint = 'TntFingerprint',

  /**
   * "TntLock" illustration type.
   */
  TntLock = 'TntLock',

  /**
   * "TntMission" illustration type.
   */
  TntMission = 'TntMission',

  /**
   * "TntNoApplications" illustration type.
   */
  TntNoApplications = 'TntNoApplications',

  /**
   * "TntNoFlows" illustration type.
   */
  TntNoFlows = 'TntNoFlows',

  /**
   * "TntNoUsers" illustration type.
   */
  TntNoUsers = 'TntNoUsers',

  /**
   * "TntRadar" illustration type.
   */
  TntRadar = 'TntRadar',

  /**
   * "TntServices" illustration type.
   */
  TntServices = 'TntServices',

  /**
   * "TntSessionExpired" illustration type.
   */
  TntSessionExpired = 'TntSessionExpired',

  /**
   * "TntSessionExpiring" illustration type.
   */
  TntSessionExpiring = 'TntSessionExpiring',

  /**
   * "TntSuccess" illustration type.
   */
  TntSuccess = 'TntSuccess',

  /**
   * "TntSuccessfulAuth" illustration type.
   */
  TntSuccessfulAuth = 'TntSuccessfulAuth',

  /**
   * "TntUnlock" illustration type.
   */
  TntUnlock = 'TntUnlock',

  /**
   * "TntUnsuccessfulAuth" illustration type.
   */
  TntUnsuccessfulAuth = 'TntUnsuccessfulAuth',

  /**
   * "Unable To Load" illustration type.
   */
  UnableToLoad = 'UnableToLoad',

  /**
   * "Unable To Load Image" illustration type.
   */
  UnableToLoadImage = 'UnableToLoadImage',

  /**
   * "Unable To Upload" illustration type.
   */
  UnableToUpload = 'UnableToUpload',

  /**
   * "Upload Collection" illustration type.
   */
  UploadCollection = 'UploadCollection'
}
